import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, throwError } from 'rxjs';
import { AnnualPlan } from "../../../common/models/annual-plan";
import { AnnualPlanMacroCycle } from "../../../common/models/annual-plan-macro-cycle";
import { AnnualPlanPhase } from "../../../common/models/annual-plan.phase";
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { Week } from "../../../common/models/week";
import { AnnualPlanService } from "../../../annual-plan/providers/annual-plans.services";
import { AnnualPlanData } from "../../../annual-plan/merger/annual-plan-data-merger";
import { AnnualPlanGraphComponent } from "../../../annual-plan/components/graph/annual-plan-graph.component";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { catchError, map } from "rxjs/operators";
import { User } from "../../../common/models/user";


@Component({
  selector: 'athlete-annual-plan-box',
  providers: [],
  styleUrls: ['./annual-plan-box.scss'],
  standalone: true,
  imports: [
    AnnualPlanGraphComponent,
    MatIcon,
    MatProgressSpinner,
    NgIf,
    RouterLink,
    MatMiniFabButton,
    MatTooltip,
    TranslateModule,
    FlexLayoutModule,
  ],
  templateUrl: './annual-plan-box.html'
})
export class AnnualPlanBoxComponent implements OnInit, OnDestroy {

    public isLoading = true;

    public annualPlan: AnnualPlan = new AnnualPlan({});
    public annualPlanMacroCycles: AnnualPlanMacroCycle[] = [];
    public annualPlanPhases: AnnualPlanPhase[] = [];

    public weeks: any;
    public clickedWeek: Week = {} as Week;

    @Input()
    public organization: Organization = {} as Organization;

    @Input()
    public athleteUser: User = {} as User;
    private subscriptions: Subscription[] = [];

    constructor(
        private annualPlanProvider: AnnualPlanService,
    ) {
    }

    public ngOnInit() {
        this.subscriptions.push(this.loadAnnualPlan().subscribe());
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public weekEventClicked(week: Week) {
        this.clickedWeek = week;
    }

    private loadAnnualPlan(): Observable<void> {
      if (!this.athleteUser?.id || !this.organization?.id) {
        console.error('Required data not available');
        return throwError(() => new Error('Athlete or organization data is missing'));
      }

      return this.annualPlanProvider.findActiveByAthleteUserId(this.organization, this.athleteUser.id!).pipe(
        map((data: AnnualPlanData) => {
          this.annualPlan = data['plan'];
          this.weeks = data['weeks'];
          this.annualPlanPhases = data['phases'];
          this.annualPlanMacroCycles = data['macroCycles'];
          this.isLoading = false;
        }),
        catchError(error => {
          return throwError(() => error);
        })
      );
    }
}
